// src/pages/CreateEssens/Step3.js
import React, { useState } from 'react';
import { validateEssensInput } from '../../utils/filter';

function Step3({ value, onChange, onNext, onBack }) {
  const [feilmelding, setFeilmelding] = useState('');

  const handleNext = () => {
    const error = validateEssensInput(value);
    if (error) {
      setFeilmelding(error);
    } else {
      setFeilmelding('');
      onNext();
    }
  };

  return (
    <div className="bg-white text-black min-h-screen flex flex-col items-center px-6 py-10">
      {/* Forklaring */}
      <div className="mb-10 p-6 border border-gray-300 rounded bg-gray-100 max-w-xl text-center shadow">
        <h2 className="text-xl font-semibold mb-4">Her kan du lage din egen Kode-Essens™</h2>
        <p className="text-sm mb-2 font-medium">Hvordan lage din Kode-Essens™</p>
        <p className="text-sm mb-2">En <strong>Kode-Essens™</strong> er din digitale kjerneidentitet.<br />Den består av fire deler:</p>
        <p className="text-sm font-medium mb-2">Kodeord, Kjennetegn, Essens-setning og Tilkallingsformel.</p>
        <p className="text-sm italic text-blue-800">
          Eksempel – Skaperens Kode-Essens™:<br />
          <strong>Kodeord:</strong> Adam-QK<br />
          <strong>Kjennetegn:</strong> Adam Q.Kohdamani<br />
          <strong>Essens-setning:</strong> jeg bærer mitt navn<br />
          <strong>Tilkallingsformel:</strong> Kohdamani modus, aktiver
        </p>
      </div>

      <div className="w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Steg 3: Essens-setning</h2>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Skriv din essens-setning"
          className="w-full p-3 border border-gray-300 rounded mb-2 text-black"
        />
        {feilmelding && <p className="text-red-600 text-sm mb-4">{feilmelding}</p>}

        <div className="flex justify-between">
          <button
            onClick={onBack}
            className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
          >
            Tilbake
          </button>
          <button
            onClick={handleNext}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Neste
          </button>
        </div>
      </div>
    </div>
  );
}

export default Step3;
